import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAlert } from 'react-alert';
import { useLoading } from '../../commons/Loading';
import { useAuth } from '../../commons/Auth';
import axios from 'axios';
import {
  useQueryParams,
  NumberParam,
  withDefault,
  StringParam,
} from 'use-query-params';
import InvoicesByMonthPresentational from './InvoicesByMonthPresentational';
import './InvoicesByMonth.scss';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

function InvoicesByMonth(props) {
  const { showLoading, hideLoading } = useLoading();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [{ newToken } = {}] = useAuth();
  const { t } = useTranslation('DASHBOARD');
  const alert = useAlert();

  const [query, setQuery] = useQueryParams({
    offset: withDefault(NumberParam, 0),
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    year: withDefault(NumberParam, new Date().getFullYear()),
    profileStatus: withDefault(StringParam),
  });

  const { offset, limit, year, profileStatus } = query;

  const fetchInvoices = async () => {
    showLoading();
    setData([]);
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/invoices-by-month`,
      {
        headers: { Authorization: newToken },
        params: { offset, limit, year, profileStatus },
      }
    );
    hideLoading();
    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }
    setData(response.data || []);
    setTotal(Number(response.headers['x-total-count']));
  };

  useEffect(() => {
    fetchInvoices();
  }, [offset, limit, year, profileStatus]);

  const onNoInvoiceConfirm = async ({ supplier, month, year }) => {
    showLoading();
    setData([]);
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/invoices-by-month/${supplier}`,
      { month, year },
      {
        headers: { Authorization: newToken },
      }
    );
    if (response instanceof Error) {
      hideLoading();
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }
    await fetchInvoices();
  };

  function onFilter(queryDiff) {
    if (
      (query.profileStatus &&
        query.profileStatus !== queryDiff.profileStatus) ||
      (profileStatus && query.profileStatus === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }
    setQuery(queryDiff);
  }

  const onQueueJobRequestConfirm = async () => {
    showLoading();

    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/queueJobRequests`,
      {
        year,
        type: 'EXTRA_INVOICE_INVOICES',
        business: 'EXTRA',
        service_type: 'invoices',
      },
      {
        headers: { Authorization: newToken },
      }
    );
    if (response instanceof Error) {
      hideLoading();
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const notCreatedNew = response.data?.notCreatedNew;

    if (notCreatedNew === false) {
      alert.success('Richiesta rendicontazione creata correttamente');
    } else if (notCreatedNew === true) {
      alert.error(
        'Richiesta rendicontazione in stato "Non gestita" giá presente. Richiesta non creata.'
      );
    }
    hideLoading();
  };

  return (
    <InvoicesByMonthPresentational
      data={data}
      total={total}
      query={query}
      onFilter={onFilter}
      onNoInvoiceConfirm={onNoInvoiceConfirm}
      fetchTotalInvoices={fetchInvoices}
      onQueueJobRequestConfirm={onQueueJobRequestConfirm}
      {...props}
    />
  );
}

export default InvoicesByMonth;
